import React from 'react';
import PropTypes from 'prop-types';

import { getPrivateDownloadUrl } from 'utils/apis/s3';

// Resolve a short-lived presigned URL on click for private (key-based) files.
// Opens the tab synchronously to avoid popup blockers, then redirects it.
const openPrivate = (file, download) => async e => {
  e.preventDefault();
  const win = window.open('', '_blank');
  const url = await getPrivateDownloadUrl(file.key || file.name, { download });
  if (url) {
    if (win) win.location = url;
    else window.location = url;
  } else if (win) {
    win.close();
  }
};

/**
 * Anchor that downloads a private-bucket file via a presigned URL. Legacy files
 * that still carry a direct `link` (not yet migrated) are linked as-is.
 */
const PrivateDownloadLink = ({ file, download, className, style, children }) => {
  if (file && file.link && !file.key) {
    return (
      <a href={file.link} className={className} style={style} target="_blank" rel="noopener noreferrer">
        {children || file.name}
      </a>
    );
  }
  return (
    <a href="#" onClick={openPrivate(file, download)} className={className} style={style}>
      {children || (file && file.name)}
    </a>
  );
};

PrivateDownloadLink.propTypes = {
  file: PropTypes.object.isRequired,
  download: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};

PrivateDownloadLink.defaultProps = {
  download: false
};

export default PrivateDownloadLink;
